import {
  GET_PROFILE_CARDS_CATALOG,
  GET_PROFILE_CARDS_CATALOG_SUCCESS,
  GET_PROFILE_CARDS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getProfileCardCatalogRed = (state: any, actions: any) => {
  switch (actions.type) {
    case GET_PROFILE_CARDS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_PROFILE_CARDS_CATALOG_SUCCESS:
      return {
        data: actions.payload,
        loading: false,
        error: null,
      };
    case GET_PROFILE_CARDS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: null,
      };
    default:
      return state;
  }
};
